export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/158d048573074872ae9cdc4851181ce087e4a919/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"